import { FormBuilderActionTypes } from './constants';
import { renameDuplicate, renameFieldDuplicate } from '../../utils/renameDuplicate';

interface State {
    formId: any | "",
    config?: any | {};
    fieldList: any[],
    boadList: any[],
    panelItems:any[]
}

const INIT_STATE = {
    formId: "",
    fieldList: [],
    boadList: [],
    panelItems:[],

    config: {
        tableName: '',
        style: {
            width: 400,
            height: 360,
        }

    },
};

const FormBuilder = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {


        case FormBuilderActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };
        case FormBuilderActionTypes.CHANGE_FORM_TABLENAME:          
            return {
                ...state,
                config: { ...state.config, tableName: action.payload?.tableName },
            };

        case FormBuilderActionTypes.CHANGE_FORMID:
            return {
                ...state,
                formId: action.payload,
            };

        case FormBuilderActionTypes.CHANGE_FIELD:           
            return {
                ...state,
                fieldList: action.payload,
            };

        case FormBuilderActionTypes.CHANGE_BOAD:          
            var t1 = renameFieldDuplicate(action.payload);
            return {
                ...state,
                boadList: t1,
            };

        case FormBuilderActionTypes.CHANGE_BOAD_SETTING:
            const boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadList = state.boadList;
            const ddd = s_boadList          

            if (boadIndex !== -1) {
                s_boadList[boadIndex] = { ...s_boadList[boadIndex], ...action.payload }
            }
          
            return {
                ...state,
                boadList: s_boadList,
            };


        default:
            return state;
    }
};

export default FormBuilder;
